import _difference from 'lodash/difference';
import _map from 'lodash/map';
import logNewRelicCustom from '../../../utils/logNewRelicCustom';
import { NEW_RELIC_EVENTS } from '../../../constants';

const getEnabledChoiceIds = (disabledChoiceIds, get) => {
  const choiceIds = Object.keys(get().choicesInfo);
  return _difference(choiceIds, disabledChoiceIds);
};

export default (set, get, ids) => {
  const objFromSet = set(
    () => ({
      disabled: ids
    }),
    false,
    { type: 'updateDisabled', ids }
  );

  const disabledChoiceIds = _map(ids, (id) => id.toString());
  const enabledChoiceIds = getEnabledChoiceIds(disabledChoiceIds, get);
  logNewRelicCustom(NEW_RELIC_EVENTS.COMPATIBILITY_CHOICES, { enabledChoiceIds, disabledChoiceIds });
  return objFromSet;
};
